import { request } from '@/shared/api/request'

export const getDeptByIin = (params) => {
	return request({ url: '/staff/universalMethods/deptByIin', method: 'GET', params })
}